import { CommandKey } from "components/icons/CommandKey";
import { Search } from "components/icons/Search";
import { SidebarStickyItem } from "components/Sidebar/SidebarStickyItem";
import { useCommandPalette } from "components/CommandPalette/CommandPaletteContext";
import {
  KEY_LABEL,
  QUICK_NAV_OPEN_SOURCE,
} from "components/CommandPalette/constants";
import { QUICK_NAV_OPENED } from "constants/analyticsEvents";
import { useAnalytics } from "hooks/useAnalytics";
import { useDeviceInfo } from "hooks/useDeviceInfo";
import { useHasCommandPalette } from "hooks/useHasCommandPalette";

const COMMAND_PALETTE_KEY = "K";

export const SearchNavItem = () => {
  const { setIsOpen } = useCommandPalette();
  const { isMac } = useDeviceInfo();
  const { hasCustomerPalette } = useHasCommandPalette();
  const { trackEvent } = useAnalytics();

  if (!hasCustomerPalette) return null;

  const modifierKey = isMac ? <CommandKey /> : KEY_LABEL.MODIFIER;

  const handleOpen = () => {
    trackEvent(QUICK_NAV_OPENED, { source: QUICK_NAV_OPEN_SOURCE.SIDEBAR });
    setIsOpen(true);
  };

  return (
    <SidebarStickyItem
      icon={Search}
      label="Search"
      onClick={handleOpen}
      suffix={
        <span className="t-flex t-items-center t-gap-1 t-px-px t-py-0.5 t-text-body-sm t-text-neutral-30">
          {modifierKey}
          {COMMAND_PALETTE_KEY}
        </span>
      }
    />
  );
};
